<template>
  <div
    :class="{
      'col-xs-12': !subModule,
      'col-sm-12': !subModule,
      'col-centered': !subModule,
      subModule,
      splashModule,
    }"
    class="hr-module-header"
  >
    <h1 v-if="!subModule">{{ title }}</h1>
    <h3 v-if="subModule">{{ title }}</h3>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'hr-module-header',
  props: {
    title: {
      type: String,
      default: null,
    },
    subModule: {
      type: Boolean,
      default: false,
    },
    splashModule: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/core/style-vars.scss';

div.hr-module-header.splashModule {
  text-align: center;
  margin-bottom: 0;
  margin-left: auto;
}

.hr-module-header {
  color: var(--dpt-text-color);
  padding: 0 18px;
  text-align: center;
}

.hr-module-header h3 {
  font-weight: $font-weight-bold;
  color: var(--dpt-text-color);
}

.hr-steps .hr-module-header p {
  font-size: 1rem;
  color: var(--dpt-text-color);
}

.hr-steps {
  margin-bottom: 50px;
  color: var(--dpt-text-color-secondary);
}

.HRModule__body__left .hr-module-header,
.HRModule__body__right .hr-module-header {
  margin-bottom: 22px;
  margin-left: 0;
  padding-left: 0;
}

.HRModule__body__right .hr-module-header.hr-module-header.subModule {
  margin-bottom: 32px;
}

.HRModule__body__right .hr-module-header h3 {
  margin-bottom: 12px;
}
</style>
